import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const SolidCardFooter = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-solid-card__footer", className)} {...other}>
      {children}
    </div>
  );
};

SolidCardFooter.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

SolidCardFooter.defaultProps = {
  className: "",
  children: null
};

export default SolidCardFooter;
